import { Autocomplete, Box, Button, Checkbox, Drawer, FormControl, FormControlLabel, Grow, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../Utility/ImagePaths';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails, CommonTimeRangePicker } from '../../../Components/Common Components/CommonComponents';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { formatDate, AmountFormat, timeOnlyConvert } from '../../../Components/CommonFunctions/CommonFunctions';
import { Colors } from '../../../Styles/Colors';
import { CurrencySymbol } from '../../../Utility/Constants';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';

class OTTatReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            doctorName: [],
            startDate: null,
            dateIndex: 1,
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            isOPT: false,
            tatReportData: [],
            totalTatTime: '0 hrs 00 mins'
        }
    }

    componentDidMount() {
        let logginedData = localGetItem('loggedInUserInfo')
        let loggedInUserInfo = JSON.parse(logginedData)
        this.setState({
            isOPT: loggedInUserInfo?.is_opt
        }, () => { this.getTatReportData() })
    }

    getTatReportData = () => {
        try {
            var { FilterDatas } = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(
                Serviceurls.OT_TAT_REPORT_GET +
                "?from_date=" + this.state.fromDate +
                "&to_date=" + this.state.toDate +
                "&start_time=" + setStartTime +
                "&end_time=" + setEndTime
            ).then((response) => {
                if (response.data.status === 'success') {
                    this.setState({
                        tatReportData: response.data.data,
                        totalTatTime: response.data.total_hours
                    })
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getTatReportPrint = () => {
        try {
            var { FilterDatas } = this.state
            let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : ''
            let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : ''
            let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            RestAPIService.getAll(
                Serviceurls.OT_TAT_REPORT_GET +
                "?from_date=" + this.state.fromDate +
                "&to_date=" + this.state.toDate +
                "&start_time=" + setStartTime +
                "&end_time=" + setEndTime +
                "&export_type=pdf"
            ).then((response) => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

    selectedTime = (start, end, error) => {
        this.state.FilterDatas.startTime = start
        this.state.FilterDatas.endTime = end
        this.setState({ FilterDatas: this.state.FilterDatas, timeError: error })
    }

    onChangeCheckBox = (e, key) => {
        try {
            let states = this.state
            states[key] = e.target.checked
            this.setState({ states })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container' emed_tid="ot_tat_report_filter_container">
                <Box component={"div"} className='eMed_filter_Top' emed_tid="ot_tat_report_filter_header">
                    <Typography variant='h6' fontWeight={600} emed_tid="ot_tat_report_filter_title">{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn' emed_tid="ot_tat_report_filter_close_btn">
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' emed_tid="ot_tat_report_filter_close_icon" />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' emed_tid="ot_tat_report_filter_content">
                    <Box className='eMed_date_filter' emed_tid="ot_tat_report_filter_date">
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true}
                            emed_tid="ot_tat_report_filter_date_picker" />
                    </Box>
                    <Box sx={{ width: '22vw' }} emed_tid="ot_tat_report_filter_time">
                        <CommonTimeRangePicker
                            startTime={this.state.FilterDatas?.startTime}
                            endTime={this.state.FilterDatas?.endTime}
                            selectedTime={this.selectedTime.bind(this)}
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            onError={this.state.FilterDatas.onError}
                            emed_tid="ot_tat_report_filter_time_picker"
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center" emed_tid="ot_tat_report_filter_footer">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false
                            }, () => { this.getTatReportData() })
                        }}
                        id="eMed_Config_btn"
                        emed_tid="ot_tat_report_filter_clear_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            this.setState({ FilterOpen: false }, () => this.getTatReportData())
                        }}
                        id="eMed_Config_btn"
                        emed_tid="ot_tat_report_filter_search_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            isSuccessMsg: false,
            isSuccessMsgText: "",
        })
    }

    gridToolBar = () => {
        var { t } = this.props
        let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : ''
        let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : ''
        let setStartTime = start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let setEndTime = end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
            TextArray.push(
                { label: "Start Time", value: timeOnlyConvert(setStartTime) },
                { label: "End Time", value: timeOnlyConvert(setEndTime) }
            )
        }
        return (
            <Box emed_tid="ot_tat_report_toolbar">
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} emed_tid="ot_tat_report_toolbar_filter" />
            </Box>

        )
    }


    render() {
        const { t } = this.props
        this.state.tatReportData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'patient_name', headerName: 'Patient Details', flex: 0.166,
                renderCell: (params) => (<Box emed_tid={`ot_tat_report_patient_details_${params.row.sno}`}><CommonPatientDetails data={params?.row} showDetailed={true} emed_tid={`ot_tat_report_patient_details_component_${params.row.sno}`} /></Box>),
                valueGetter: (params) => {
                const Name = params.row?.patient_name  || "";
                const Mobile = params.row?.patient_mobile_no  || "";
                const UHID = params.row?.uhid  || "";
                return `${Name} ${Mobile} ${UHID}`;
            }
            },
            {
                field: 'surgery_name', headerName: 'Surgery Name', flex: 0.166,
                renderCell: (params) => (<Box component={'div'} emed_tid={`ot_tat_report_surgery_name_${params.row.sno}`}>{params?.row?.surgery_name ? params?.row?.surgery_name : '-'}</Box>)
            },
            {
                field: 'admission_date', headerName: 'Admission Date and Time', flex: 0.166,
                renderCell: (params) => (<Box component={'div'} emed_tid={`ot_tat_report_admission_date_${params.row.sno}`}>{params?.row?.admission_date ? params?.row?.admission_date : '-'}</Box>)
            },
            {
                field: 'arrived_date', headerName: 'OT Arrived Time', flex: 0.166,
                renderCell: (params) => (<Box component={'div'} emed_tid={`ot_tat_report_arrived_date_${params.row.sno}`}>{params?.row?.arrived_date ? params?.row?.arrived_date : '-'}</Box>)
            },
            {
                field: 'surgery_completed_date', headerName: 'Completed Time', flex: 0.166,
                renderCell: (params) => (<Box component={'div'} emed_tid={`ot_tat_report_surgery_completed_date_${params.row.sno}`}>{params?.row?.surgery_completed_date ? params?.row?.surgery_completed_date : '-'}</Box>)
            },
            {
                field: 'turn_around_time', headerName: 'Turn Around Time', flex: 0.166,
                renderCell: (params) => (<Box component={'div'} emed_tid={`ot_tat_report_turn_around_time_${params.row.sno}`}>{params?.row?.turn_around_time ? params?.row?.turn_around_time : '-'}</Box>)
            },
        ]
        return (
            <Box component={'div'} className='eMed_rts_container' emed_tid="ot_tat_report_container">
                <Box component={"div"} className='eMed_Top_Container' emed_tid="ot_tat_report_header">
                    <Box component={"div"} className='eMed_Cards_Container' emed_tid="ot_tat_report_cards_container">
                        <div emed_tid="ot_tat_report_avg_tat_time_card">{AmountsCard(t("AVG TAT Time"), this.state.totalTatTime, true)}</div>
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container' emed_tid="ot_tat_report_action_container">
                        <Box component={"div"} className='eMed_Filter_Icon_div' emed_tid="ot_tat_report_filter_container">
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }} emed_tid="ot_tat_report_filter_btn">
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' emed_tid="ot_tat_report_filter_icon" />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.getTatReportPrint() }} emed_tid="ot_tat_report_print_btn">
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' emed_tid="ot_tat_report_print_icon" />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table' emed_tid="ot_tat_report_table_container">
                    <DataGrid
                        rows={this.state.tatReportData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata' emed_tid="ot_tat_report_no_records">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                        loading={this.state.isLoader}
                        emed_tid="ot_tat_report_datagrid"
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                    emed_tid="ot_tat_report_filter_drawer"
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="ot_tat_report_error_toast"
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(OTTatReport)